import type { Util } from "./util";
import { util } from "./util";
import type { SearchHandler } from "./searchHandler";
import { searchHandler } from "./searchHandler";
import type { OTracking } from "./types/tracking";
import type { Tracking } from "./tracking";
import { tracking } from "./tracking";
import type { Features } from "./features";
import { initFeatureFlags } from "./features";
import { searchSuggest } from "./searchSuggest";
import { searchForm } from "./SearchForm";
import { searchbar } from "./Searchbar";
import { suggestTracking } from "./suggestTracking";
import { GlobalUtils } from "@otto-ec/global-resources/types/head/global-utils";
import { submitHistory } from "./SubmitHistory";
import { searchHistory } from "./searchHistory";
import { emptyStateSuggest } from "./emptyStateSuggest";
import { suggestLayer } from "./SuggestLayer";
import { GlobalEvents } from "@otto-ec/global-resources";

export interface Squirrel extends Features {
  searchbar: typeof searchbar;
  searchHandler: SearchHandler;
  searchSuggest: typeof searchSuggest;
  suggestTracking: typeof suggestTracking;
  util: Util;
  searchForm: typeof searchForm;
  tracking: Tracking;
  submitHistory: typeof submitHistory;
  searchHistory: typeof searchHistory;
  emptyStateSuggest: typeof emptyStateSuggest;
  suggestLayer: typeof suggestLayer;
}

declare global {
  interface Window {
    o_squirrel: Squirrel;
    o_tracking: OTracking;
    o_util: GlobalUtils;
    squirrelTrackingInitialized: boolean;
  }
}

window.o_squirrel ||= {} as never;
initFeatureFlags(window.o_squirrel);
window.o_squirrel.util = util;
window.o_squirrel.searchForm = searchForm;
window.o_squirrel.searchHandler = searchHandler;
window.o_squirrel.tracking = tracking;
window.o_squirrel.searchSuggest = searchSuggest;
window.o_squirrel.searchbar = searchbar;
window.o_squirrel.suggestTracking = suggestTracking;
window.o_squirrel.submitHistory = submitHistory;
window.o_squirrel.searchHistory = searchHistory;
window.o_squirrel.emptyStateSuggest = emptyStateSuggest;
window.o_squirrel.suggestLayer = suggestLayer;
window.o_squirrel.searchbar();
window.o_squirrel.searchHandler.init();
